import {
  B1,
  B2,
  B5,
  WebDatePicker,
  colors as zetColors,
} from '@zet/design-system'
import { Icon } from '@zet/design-system/index'
import { Stack } from '@zet/design-system/layout'

const DateSelector = ({
  label,
  onChange,
  onBlur,
  value,
  errors,
  isRequired = true,
}) => {
  return (
    <Stack className="mt-1">
      <B2 className="text-grays-80 mb-1">
        {label}
        {isRequired ? <B1 className="text-error-100 ml-1">*</B1> : <></>}
      </B2>
      <Icon
        type="CalenderOutlined"
        color={zetColors.grays[50]}
        className="absolute mt-6 pl-2 pt-1"
        size={36}
      ></Icon>

      {/* {!value && (
        <Stack className="absolute left-3 ml-4 mt-6 pt-1">
          <SH1 className="text-grays-50">DD/MM/YYYY</SH1>
        </Stack>
      )} */}
      <WebDatePicker
        onChange={(v) => {
          onChange(v?.target?.value)
        }}
        onBlur={onBlur}
        value={value}
        style={{
          color: '#2F3440',
          paddingLeft: 42,
        }}
      />
      {errors?.name?.message ? (
        <Stack className="mt-2">
          <B5 className="text-error-100">{errors?.name?.message}</B5>
        </Stack>
      ) : null}
    </Stack>
  )
}

export default DateSelector
